import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import CharacterSection from "../components/CharacterSection";
import Features from "../components/Features";
import HowItWorks from "../components/HowItWorks";
import SeoBlock from "../components/SeoBlock";
import FAQ from "../components/FAQ";
import BottomSeo from "../components/BottomSeo";
import Footer from "../components/Footer";
import FloatingCTA from "../components/FloatingCTA";
import { characters, faqs, SITE_URL } from "../data/characters";

const Home = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <>
      <Helmet>
        <html lang="en" />
        <title>
          Character AI Chat – Chat With AI Characters That Remember You
        </title>
        <meta
          name="description"
          content="Start character AI chat online with immersive AI characters, memory, roleplay, instant replies, private conversations and custom personalities."
        />
        <link rel="canonical" href={`${SITE_URL}/`} />
        <meta property="og:url" content={`${SITE_URL}/`} />
        <meta
          property="og:title"
          content="Character AI Chat – Chat With AI Characters That Remember You"
        />
        <meta
          property="og:description"
          content="Start character AI chat online with immersive AI characters, memory, roleplay, instant replies, private conversations and custom personalities."
        />
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>

      <div id="top" data-testid="app-root" className="bg-white text-black">
        <Header />
        <main>
          <Hero />
          <Marquee />

          <section
            id="characters"
            aria-labelledby="characters-heading"
            data-testid="characters-section"
          >
            <h2 id="characters-heading" className="sr-only">
              Meet the AI Characters
            </h2>
            {characters.map((c, i) => (
              <CharacterSection key={c.id} character={c} index={i} />
            ))}
          </section>

          <Features />
          <HowItWorks />
          <SeoBlock />
          <FAQ />
          <BottomSeo />
        </main>
        <Footer />
        <FloatingCTA />
      </div>
    </>
  );
};

export default Home;
